import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { MutationInputError } from 'providers/tanstack-query/errors'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { UPDATE_PUBLISHER_FOR_TABLE } from './api/mutation'
import { Data } from './api/types'
import { UseUpdatePublisher, UseUpdatePublisherProps, Variables } from './types'

export const useUpdatePublisher = ({ email }: UseUpdatePublisherProps): UseUpdatePublisher => {
  const { t } = useTranslation('features/user')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<MutationInputError[]>([])

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_PUBLISHER_FOR_TABLE,
    onCompleted: async (data: Data) => {
      const {
        updatePublisherWorkspaceRole: { errors },
      } = data

      if (errors) {
        setErrors(errors)
        enqueueSnackbar(t('list.update.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('list.update.success', { email }), {
          variant: 'success',
        })
      }
    },
    queriesToInvalidate: ['getPublishersForTable'],
  })

  const update = (variables: Variables): void => {
    void mutateAsync({
      input: variables,
    })
  }

  return { errors, update }
}
